import { rankMedal, podiumClass, type CompanyAggregate } from '@/lib/leaderboard';
import { useCurrentPlayer } from '@/app/store';

interface CompanyTableProps {
  companies: CompanyAggregate[];
  startRank?: number;
}

export function CompanyTable({ companies, startRank = 0 }: CompanyTableProps) {
  const me = useCurrentPlayer();

  if (companies.length === 0) {
    return (
      <div className="lb-empty">
        👋 ¡Sé el primero en jugar y lleva tu empresa al ranking!
      </div>
    );
  }

  return (
    <div className="lb-table-wrap">
      <table className="lb-table">
        <thead>
          <tr>
            <th className="col-rank">#</th>
            <th>Empresa</th>
            <th className="r">Jugadores</th>
            <th className="r">Mejor</th>
            <th className="r">Total</th>
            <th className="r col-total">PROMEDIO</th>
          </tr>
        </thead>
        <tbody>
          {companies.map((c, i) => {
            const absoluteIdx = startRank + i;
            const isMyCompany = me?.company === c.name;
            return (
              <tr
                key={c.name}
                className={`lb-row ${podiumClass(absoluteIdx)} ${isMyCompany ? 'is-me' : ''}`}
              >
                <td className="col-rank">
                  <span className="rank-num">{rankMedal(absoluteIdx)}</span>
                </td>
                <td>
                  <strong>{c.name}</strong>
                  {isMyCompany && <span className="me-tag">tu equipo</span>}
                </td>
                <td className="r">{c.count}</td>
                <td className="r" style={{ color: 'var(--blue-lite)' }}>
                  {c.best.toLocaleString()}
                </td>
                <td className="r" style={{ color: 'var(--ink)' }}>
                  <strong>{c.total.toLocaleString()}</strong>
                </td>
                <td className="r col-total">
                  <strong>{c.avg.toLocaleString()}</strong>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
